import {MastercardResult, VisaResult} from "@/model/transaction-enums";

export class TransactionPreview {
  id = 0;
  paymentId = '';
  color = '';
  productType = '';
  receiptDateEst: Date = new Date();
  countryCodeFrom = '';
  countryCodeTo = '';
  planName = '';
  currency = '';
  amount = 0;
  paymentMethod = '';
  authorizeMethod = '';
  txResult = '';
  type = '';
  msisdn = '';
  userInfo = '';
  paymentState = '';
  technology = '';
  creditCardToken = '';
  paypalPayerId = '';
  userId = '';
  creditCardAvsResult = '';
  initialPrimaryBalance = '';
  finalPrimaryBalance = '';
  initialLoanBalance = '';
  bankResponseCode = '';
  creditCardBrand = '';
  paymentErrorDescription = '';
  errorMessage = '';
  ipAddress = '';

  fraudCaseTransactionList: {fraudCaseId: string}[] = [];

  get avsMessage() {
    let desc;
    switch (this.creditCardBrand) {
      case 'VISA':
        desc = (VisaResult as any)[this.creditCardAvsResult];
        break;
      case 'MASTERCARD':
        desc = (MastercardResult as any)[this.creditCardAvsResult];
    }
    if (desc) {
      return this.creditCardAvsResult + ' - ' + (VisaResult as any)[this.creditCardAvsResult];
    }
    return '';
  }
}



